export const REGIONS = {
    AT: {
        name: "Österreich",
        gmapPostionOptions: {
            mapCenter: {
                lat: 47.516231,
                lng: 14.550072
            },
            mapZoom: 7,
        }
    },
    CH: {
        name: "Schweiz",
        gmapPostionOptions: {
            mapCenter: {
                lat: 46.818188,
                lng: 8.227511999999999
            },
            mapZoom: 7,
        }
    },
    DE_BW: {
        name: "Baden-Württemberg", gmapPostionOptions: {
            mapCenter: {
                lat: 48.6616037,
                lng: 9.350133599999999
            },
            mapZoom: 7,
        }
    },
    DE_BY: {
        name: "Bayern",
        gmapPostionOptions: {
            mapCenter: {
                lat: 48.7904472,
                lng: 11.4978895
            },
            mapZoom: 7,
        }
    },
    DE_BE: {
        name: "Berlin",
        gmapPostionOptions: {
            mapCenter: {
                lat: 52.52000659999999,
                lng: 13.404954
            },
            mapZoom: 10,
        }
    },
    DE_BB: {
        name: "Brandenburg",
        gmapPostionOptions: {
            mapCenter: {
                lat: 52.1313922,
                lng: 13.2162494
            },
            mapZoom: 7,
        }
    },
    DE_HB: {
        name: "Bremen",
        gmapPostionOptions: {
            mapCenter: {
                lat: 53.07929619999999,
                lng: 8.8016936
            },
            mapZoom: 10,
        }
    },
    DE_HH: {
        name: "Hamburg",
        gmapPostionOptions: {
            mapCenter: {
                lat: 53.5510846,
                lng: 9.9936819
            },
            mapZoom: 10,
        }
    },
    DE_HE: {
        name: "Hessen",
        gmapPostionOptions: {
            mapCenter: {
                lat: 50.6520515,
                lng: 9.162437599999999
            },
            mapZoom: 7,
        }
    },
    DE_MV: {
        name: "Mecklenburg-Vorpommern",
        gmapPostionOptions: {
            mapCenter: {
                lat: 53.6126505,
                lng: 12.4295953
            },
            mapZoom: 7,
        }
    },
    DE_NI: {
        name: "Niedersachsen",
        gmapPostionOptions: {
            mapCenter: {
                lat: 52.6367036,
                lng: 9.845076600000001
            },
            mapZoom: 7,
        }
    },
    DE_NW: {
        name: "Nordrhein-Westfalen",
        gmapPostionOptions: {
            mapCenter: {
                lat: 51.43323669999999,
                lng: 7.661593799999999
            },
            mapZoom: 7,
        }
    },
    DE_RP: {
        name: "Rheinland-Pfalz",
        gmapPostionOptions: {
            mapCenter: {
                lat: 50.118346,
                lng: 7.3089527
            },
            mapZoom: 7,
        }
    },
    DE_SL: {
        name: "Saarland",
        gmapPostionOptions: {
            mapCenter: {
                lat: 49.3964234,
                lng: 7.0229607
            },
            mapZoom: 9,
        }
    },
    DE_SN: {
        name: "Sachsen",
        gmapPostionOptions: {
            mapCenter: {
                lat: 51.1045407,
                lng: 13.2017384
            },
            mapZoom: 7,
        }
    },
    DE_ST: {
        name: "Sachsen-Anhalt", gmapPostionOptions: {
            mapCenter: {
                lat: 51.9502649,
                lng: 11.6922734
            },
            mapZoom: 7,
        }
    },
    DE_SH: {
        name: "Schleswig-Holstein", gmapPostionOptions: {
            mapCenter: {
                lat: 54.21936720000001,
                lng: 9.696116700000001
            },
            mapZoom: 7,
        }
    },
    DE_TH: {
        name: "Thüringen", gmapPostionOptions: {
            mapCenter: {
                lat: 51.0109892,
                lng: 10.845346
            },
            mapZoom: 7,
        }
    },
};


export const LANGUAGES = {
    javascript: "JavaScript",
    python: "Python",
    java: "Java",
    php: "PHP",
    csharp: "C#",
    cpp: "C / C++",
    dockerfile: "Docker",
    abap: "ABAP",
    kotlin: "Kotlin",
    powershell: "PowerShell",
    rust: "Rust",
};

export const CODE_COMMENT_JUDGEMENT_CHOICES = new Map();
CODE_COMMENT_JUDGEMENT_CHOICES.set("HEART_EYED", {imageUrl: 'https://res.cloudinary.com/dspi5zyaa/image/upload/v1644851616/eh-platform/icons/smashicons_monster_emojis_heart-eyed-icon-16-cartoony.svg'});
CODE_COMMENT_JUDGEMENT_CHOICES.set("SMILE", {imageUrl: 'https://res.cloudinary.com/dspi5zyaa/image/upload/v1644852371/eh-platform/icons/smashicons_monster_emojis_excided-icon-11-cartoony.svg'});
CODE_COMMENT_JUDGEMENT_CHOICES.set("NEUTRAL", {imageUrl: 'https://res.cloudinary.com/dspi5zyaa/image/upload/v1644851617/eh-platform/icons/smashicons_monster_emojis_not-amused-icon-21-cartoony.svg'});
CODE_COMMENT_JUDGEMENT_CHOICES.set("SLIGHTLY_FROWNING_FACE", {imageUrl: 'https://res.cloudinary.com/dspi5zyaa/image/upload/v1644851615/eh-platform/icons/smashicons_monster_emojis_confused-icon-24-cartoony.svg'});
CODE_COMMENT_JUDGEMENT_CHOICES.set("ANNOYED", {imageUrl: 'https://res.cloudinary.com/dspi5zyaa/image/upload/v1644851615/eh-platform/icons/smashicons_monster_emojis_annoyed-icon-14-cartoony.svg'});
CODE_COMMENT_JUDGEMENT_CHOICES.set("THUMB_UP", {imageUrl: 'https://res.cloudinary.com/dspi5zyaa/image/upload/v1644851940/eh-platform/icons/smashicons_essentials_2_1_like-icon-31-cartoony.svg'});
CODE_COMMENT_JUDGEMENT_CHOICES.set("THUMB_DOWN", {imageUrl: 'https://res.cloudinary.com/dspi5zyaa/image/upload/v1644851940/eh-platform/icons/smashicons_essentials_2_1_dislike-icon-32-cartoony.svg'});

export const SIGNS = [
    {sign: ' ', replacement: ' '}
];

export const DIFFICULTIES = [
    {
        name: 'leicht',
        icon: 'difficulty-icon-easy-new'
    },
    {
        name: 'mittel',
        icon: 'difficulty-icon-intermediate-new'
    },
    {
        name: 'schwer',
        icon: 'difficulty-icon-hard-new'
    },
    {
        name: 'hardcore',
        icon: 'difficulty-icon-extra-hard-new'
    },
]

export const HEATMAP_LOCALE_DE = {
    "months": ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
    "days": ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    "on": "am",
    "less": "wenig",
    "more": "viel"
};
export const HEATMAP_COLORS = ["#E4F0FB", "#60D6C9", "#08AB99", "#067A6C", "#04443D"];
export const HEATMAP_TOOLTIP = "Aktion(en)";
export const TOP30_WATERPUMPS_CHALLENGE = [
    "038349b1454267be5e6f91e2704aa6d8",
    "bf4dbd4379deda4276833e8737af3554",
    "5641479baf2b7330c290c223626e5446",
    "c54ac6e2441fcb169000653db6bb1e92",
    "af801e726acfd65ead872b9498bd0f89",
    "5de720ec9d931fc453eeb7edc3cb7c35",
    "6d528b2f65aaf3b876ae5b66228f539c",
    "ca2af1724abd068b064179c1c56c9687",
    "6dd6ee18cfbb3762248f384024428a92",
    "9ad805b16b8e3ec4b959ed74567d7f8c",
    "8699167b222fb7913fa864b59c391d4b",
    "e5e498ae92b5087cf15d0b7f271b380d",
    "388fa27f370927590f3ce3f3cfeb91af",
    "62f68823dc7034064dbb6cd483f2219d",
    "35752bfa1b5e6cd7687e61a7c7d2cc6c",
    "bfdbfbcfa77ea24488faa85d1f006267",
    "2518734905ac5089ed2c5cb3b7f79d93",
    "3610762ee1d3078eede19a3fe70529b5",
    "a011fa0485070e8c2545680824ad6a2b",
    "db53e995cf6abd316f52c402d43839c2",
    "52714731cbccc12e9a59706fb4628b5e",
    "8185986a060e63c7b9600a2a18364149",
    "59a6f103641aeadbe74fed6083a73e57",
    "7ac4a408ce6f4fcfaeb08e5ea835d8f0",
    "095bc72467548aa92d5a19fef4052978",
    "74c98f3dedf01379bf3a86af4b51ef18",
    "03b32f1bf7d303082cc79b05436428be",
    "9fd3dd4228b20aeb6168270e059b8acc",
    "d4cb1ab9a024998768083d984d138842",
    "d6f1b778015c9cc42f0a10e7c4aa8ffa"
];